// The Go backend's fallback error. Lives in its own leaf module so both the
// language-lowering core (gogen.ts) and the platform builtins (builtins.ts) can
// throw it without a dependency cycle between them.

/** Thrown for a construct the Go backend can't lower (e.g. tables, or a builtin
 *  it doesn't implement). The Go path has no dynamic safety net, so `stm go`
 *  surfaces this as an error; the interpreter still runs such a program.
 *  Re-exported from `gogen.ts`, which is where callers import it from. */
export class GoGenError extends Error {}
